import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { PaginatePipe } from 'src/app/pipes/paginate.pipe';
import { PipeModule } from 'src/app/pipes/pipe-module';
import { AdminMantenimientoProductosBackview } from './admin-mantenimiento-productos.component.backview';
import { NgxSpinnerModule } from "ngx-spinner";
import { MatMenuModule } from '@angular/material/menu';
import { HeaderModule } from '../header/header.module';
import { FooterModule } from '../footer/footer.module';
import { AdminMantenimientoProductoPresentacionesModule } from '../admin-mantenimiento-productos-presentaciones/admin-mantenimiento-productos-presentaciones.module';


@NgModule({
  declarations: [AdminMantenimientoProductosBackview
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatPaginatorModule,
    PipeModule,
    NgxSpinnerModule,
    HeaderModule,
    FooterModule,
    MatMenuModule,
    AdminMantenimientoProductoPresentacionesModule
  ],
  exports: [
    AdminMantenimientoProductosBackview]
})
export class AdminMantenimientoProductosModule { }
